import WarningCard from 'app/shared-components/WarningCard'

import useStyles from './PopupWarning.styles'

const PopupWarning = () => {
    const {
        classes,
    } = useStyles()

    return (
        <WarningCard
            classNames={{
                container: classes.container,
            }}
        >
            <span className={classes.bold}>IMPORTANT: </span>
            You are about to perform a bulk action that affects all the selected loggers
            and will update them regardless.
            If you are unsure, please go back and adjust your selection.
        </WarningCard>
    )
}

export default PopupWarning
